import Vue from 'vue';
import BotaoWhatsapp from '../../botao-whatsapp/components/BotaoWhatsapp';

function createVueBotaoWhatsapp(elemento){
    if(!elemento){
        return;
    }
    
    new Vue({
        el: elemento,
        components: { BotaoWhatsapp }
    });
}

const init = () => {
    const botoes = document.getElementsByClassName('payt-button-whatsapp');
    for (let botao of botoes){
        createVueBotaoWhatsapp(botao);
    }
}

if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                init();
                observer.disconnect();
            }
        });
    }, { rootMargin: '200px' });
    const target = document.querySelector('.payt-button-whatsapp');
    if (target) {
        observer.observe(target);
    } else {
        init();
    }
} else {
    init();
}